<template>
  <Spinner v-if="loading"></Spinner>
  <div v-else>
    <v-row>
      <v-col lg="4" cols="sm" class="pb-2">
        <v-card>
          <v-row class="no-gutters">
            <div class="col-auto">
              <div class="cyan fill-height">&nbsp;</div>
            </div>
            <div class="col pa-3 py-4 cyan--text">
              <h5 class="text-truncate text-uppercase">Polls</h5>
              <h1>{{ polls.length }}</h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col lg="4" cols="sm" class="pb-2">
        <v-card>
          <v-row class="no-gutters">
            <div class="col-auto">
              <div class="primary fill-height">&nbsp;</div>
            </div>
            <div class="col pa-3 py-4 primary--text">
              <h5 class="text-truncate text-uppercase">Users</h5>
              <h1>{{ users.length }}</h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col lg="4" cols="sm" class="pb-2">
        <v-card>
          <v-row class="no-gutters">
            <div class="col-auto">
              <div class="success fill-height">&nbsp;</div>
            </div>
            <div class="col pa-3 py-4 light-blue--text">
              <h5 class="text-truncate text-uppercase">Votes</h5>
              <h1>{{ results.length }}</h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="mx-auto text-center">
          <v-card-title class="primary--text">
            Voting Activity
          </v-card-title>
          <v-sparkline
            :labels="sparklineLabels"
            :value="sparklineData"
            padding="18"
            label-size="4"
            color="cyan"
            :gradient="['#007bff', 'cyan']"
            :line-width="2"
            :stroke-linecap="'round'"
          >
          </v-sparkline>
          <v-card-actions class="py-4 justify-center">
            <v-btn color="primary" to="/admin/reports">View Report</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <!--
  <v-container fluid>
    <h2>Dashboard</h2>
    <v-row>
      <v-col cols="4">
        <Polls />
      </v-col>
      <v-col cols="4">
        <v-card tile>
          <v-card-subtitle>Users</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card tile>
          <v-card-subtitle>Results</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  -->
</template>
<script>
//import Polls from "@/components/Admin/Dashboard/Polls";
import api from '@/services/api';
import { mapState } from 'vuex';
import Spinner from '@/components/Elements/Spinner.vue';
export default {
  components: {
    Spinner
    //Polls
  },
  data: () => ({
    loading: true,
    polls: null,
    user: null,
    results: null,
    sparklineData: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ],
    sparklineLabels: [
      '0h',
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      '23h'
    ]
  }),
  computed: {
    ...mapState({ event: (state) => state.events.event })
  },
  async created() {
    this.polls = await api.getPolls(this.event._id);
    this.users = await api.getUsers(this.event._id);
    this.results = await api.getVotes(this.event._id);

    this.results.forEach((item) => {
      //console.log(new Date(item.updatedAt).getUTCHours());
      this.sparklineData[new Date(item.updatedAt).getUTCHours()] += Number(
        item.count
      );
      //this.sparklineLabels.push(new Date(item.updatedAt).getUTCHours());
    });
    //console.log(this.sparklineData);
    //this.sparklineLabels = this.sparklineData.map((item, index) => index);
    this.loading = false;
    // this.polls = polls.map((item) => {
    //   return { name: item.pollText, answerCount: item.answers.length };
    // });
  }
};
</script>
